import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/site/ProtectedRoute";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ContentPage from "@/pages/ContentPage";
import FaqsPage from "@/pages/FaqsPage";
import GalleryPage from "@/pages/GalleryPage";
import StoriesPage from "@/pages/StoriesPage";
import ContactPage from "@/pages/ContactPage";
import DonatePage from "@/pages/DonatePage";
import InsurancePage from "@/pages/InsurancePage";
import GreenShieldPage from "@/pages/GreenShieldPage";
import OtherInsurancePage from "@/pages/OtherInsurancePage";
import ResourcesPage from "@/pages/ResourcesPage";
import TeamPage from "@/pages/TeamPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MobileCallBar from "@/components/site/MobileCallBar";
import { ChatWidget } from "@/components/site/ChatWidget";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminBlog from "@/pages/admin/AdminBlog";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admission/preparing-for-your-stay" element={<ContentPage />} />
            <Route path="/admission/during-your-stay" element={<ContentPage />} />
            <Route path="/admission/financing-your-stay" element={<ContentPage />} />
            <Route path="/about/what-we-treat" element={<ContentPage />} />
            <Route path="/about/team" element={<TeamPage />} />
            <Route path="/about/get-involved" element={<ContentPage />} />
            <Route path="/programs/inpatient-treatment" element={<ContentPage />} />
            <Route path="/programs/aftercare" element={<ContentPage />} />
            <Route path="/programs/family-care" element={<ContentPage />} />
            <Route path="/faqs" element={<FaqsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/stories" element={<StoriesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/insurance" element={<InsurancePage />} />
            <Route path="/verify-benefits" element={<InsurancePage />} />
            <Route path="/greenshield" element={<GreenShieldPage />} />
            <Route path="/other-insurance" element={<OtherInsurancePage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/resources/:slug" element={<BlogPost />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/leads" element={<ProtectedRoute><AdminLeads /></ProtectedRoute>} />
            <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
          </Routes>
          <MobileCallBar />
          <ChatWidget />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
